export default __webpack_public_path__ + "static/media/Lip_1_F.be7d8761.svg";